import { useTranslation } from "react-i18next";
import { Button } from "../../../../../../shared/components/button/Button";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "../../../../../../shared/components/card/Card";
import FixedScrollArea from "../../../../../../shared/components/scroll-area/FixedScrollArea";
import ActionsPerformanceDataExplorerPreviewTable from "./ActionsPerformanceDataExplorerPreviewTable";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../../../../../../shared/components/dropdown-menu/DropdownMenu";

const ActionsPerformanceDataExplorerPreview = ({
  onSubmitHandler,
  onDownloadHandler,
  previewData,
}) => {
  const { t } = useTranslation();

  return (
    <Card className="min-h-[50vh] max-h-[50vh]">
      <CardHeader className="flex flex-row justify-between">
        <CardTitle>
          {t("dataExplorers.actionsPerformance.preview.title", {
            count: previewData?.rows.length,
          })}
        </CardTitle>
        <div className="flex flex-row gap-x-2">
          <Button onClick={onSubmitHandler}>
            {t("dataExplorers.actionsPerformance.preview.previewButton")}
          </Button>
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button>
                {t(
                  "dataExplorers.actionsPerformance.preview.downloadButton.label",
                )}
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent>
              <DropdownMenuItem onClick={() => onDownloadHandler("es")}>
                {t(
                  "dataExplorers.actionsPerformance.preview.downloadButton.es",
                )}
              </DropdownMenuItem>
              <DropdownMenuItem onClick={() => onDownloadHandler("en")}>
                {t(
                  "dataExplorers.actionsPerformance.preview.downloadButton.en",
                )}
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </CardHeader>
      <CardContent>
        <FixedScrollArea className="h-[35vh]">
          <ActionsPerformanceDataExplorerPreviewTable data={previewData} />
        </FixedScrollArea>
      </CardContent>
    </Card>
  );
};

export default ActionsPerformanceDataExplorerPreview;
